import { Injectable } from '@angular/core';
import Swal, { SweetAlertIcon } from 'sweetalert2';

export interface SwalMessageOptions {
    title: string,
    showConfirmButton: boolean,
    type: SweetAlertIcon,
    confirmButtonText: string,
    cancelButtonText: string,
    reverseButtons: boolean
}

export interface SwalResultMessage {
    title: string,
    text: string,
}
@Injectable({
    providedIn: 'root'
})
export class SwalUtil {

    swalWithBootstrapButtons;

    constructor() {
        this.swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-danger mx-2',
            },
            buttonsStyling: false
        });
    }

    popupMessage(message: string, type: SweetAlertIcon) {
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: 'btn btn-success btn-madelife',
                cancelButton: 'btn btn-danger',
            },
            buttonsStyling: false,
        });

        swalWithBootstrapButtons
            .fire({
                title: '',
                text: message,
                icon: type,
                showCancelButton: false,
                confirmButtonText: 'Entendi',
                reverseButtons: false,
            });
    }

    popupChoiceMessage(message: string, parseOptions: Partial<SwalMessageOptions>, confirm: () => Promise<SwalResultMessage>, cancel: () => Promise<SwalResultMessage>) {

        const options = this.getOptions(parseOptions);

        this.swalWithBootstrapButtons.fire({
            title: options?.title,
            text: message,
            icon: options?.type,
            showCancelButton: true,
            confirmButtonText: options?.confirmButtonText,
            cancelButtonText: options?.cancelButtonText,
            reverseButtons: options?.reverseButtons,
        }).then((result) => {
            if (result.isConfirmed) {
                confirm().then((data) => {
                    this.swalWithBootstrapButtons.fire({
                        icon: 'success',
                        title: data.title,
                        text: data.text,
                        showConfirmButton: false,
                        timer: 1.5 * 1000
                    });
                });
            } else {
                cancel().then((data) => {
                    this.swalWithBootstrapButtons.fire({
                        icon: 'info',
                        title: data.title,
                        text: data.text,
                        showConfirmButton: false,
                        timer: 1.5 * 1000
                    });
                });;
            }
        });
    }

    private getOptions(parseOptions?: Partial<SwalMessageOptions>) {
        const defaultOptionsValues = {
            title: '',
            showConfirmButton: false,
            type: 'info',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Não, cancelar!',
            reverseButtons: false
        }

        return {
            ...defaultOptionsValues,
            ...parseOptions
        }
    }


  public success(msg: string, title?: string): void {
    this.showAlertFire(title, msg, 'success')
  }

  public error(msg: string, title?: string): void {
    this.showAlertFire(title, msg, 'error')
  }

  public info(msg: string, title?: string): void {
    this.showAlertFire(title, msg, 'info')
  }

  public warning(msg: string, title?: string): void {
    this.showAlertFire(title, msg, 'warning')
  }

  public html(text, icon: SweetAlertIcon) {
    this.swalWithBootstrapButtons.fire({
      html: '<pre>' + text + '</pre>',
      customClass: {
        popup: 'format-pre',
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger mx-2',
      },
      icon,
    })
  }

  private showAlertFire(
    title: string,
    msg: string,
    icon: SweetAlertIcon
  ): void {
    Swal.fire(title, msg, icon)
  }
}
